import React, { useEffect } from "react";
import { useEcosystemUsers } from "../../../application/usuarios_ecosistema/hooks/useEcosystemUsers";
import DynamicTable from "../../ui/table2";
import ToolbarComponent from "../../ui/section";

const EcosystemUsersView = (props) => {
    const {
        columns,
        data,
        customElements,
        isLoading,
        getAll,
    } = useEcosystemUsers(props);

    useEffect(() => {
        getAll();
    }, [getAll]);

    return <>
        <ToolbarComponent label="Usuarios ecosistema" showBackButton={false}>
            <DynamicTable
                headers={columns}
                data={data}
                customElements={customElements}
                tableLabel="Mis canjes"
                fullPage={true}
                showLabel={false}
                itemsPerPage={50}
                isLoading={isLoading}
            />
        </ToolbarComponent>
    </>
}

export default EcosystemUsersView;